import { render, staticRenderFns } from "./MembershipPointExpirationParts.vue?vue&type=template&id=6ceee45f&scoped=true"
import script from "./MembershipPointExpirationParts.vue?vue&type=script&lang=ts"
export * from "./MembershipPointExpirationParts.vue?vue&type=script&lang=ts"
import style0 from "./MembershipPointExpirationParts.vue?vue&type=style&index=0&id=6ceee45f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceee45f",
  null
  
)

export default component.exports